"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialApiVersionRegistry = void 0;
exports.getFinancialEndpointVersion = getFinancialEndpointVersion;
const appointment_api_version_registry_1 = require("./appointment-api-version-registry");
exports.FinancialApiVersionRegistry = [
    { endpoint: 'createPayment', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'issueReceipt', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'cancelReceipt', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'creditAdvanceDeposit', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'debitAdvanceDeposit', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'settleDeposit', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'processRefund', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'activateTariff', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'activatePackage', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'applyDiscount', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'recordPostingEvent', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'resolveApprovalChain', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'computeChargeBilling', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'billAgainstAdvance', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'billAndCreatePayment', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'processCorporateBilling', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
    { endpoint: 'processInsuranceBilling', version: 'v1', status: 'STABLE', introducedIn: '5C.4' },
];
function getFinancialEndpointVersion(endpoint) {
    return (0, appointment_api_version_registry_1.findEndpointVersion)(endpoint, exports.FinancialApiVersionRegistry);
}
//# sourceMappingURL=financial-api-version-registry.js.map